import T from '../../services/language';
import {Control, ControlRow, InputView, LabelView, LabelView2, SelectView, TextAreaView} from "./style";

export default function Product(props) {
    const {draft, putDraft, postalCode} = props;

    return (
        <>
            <Control>
                <LabelView>{T('Choose time')}</LabelView>
                <SelectView
                    value={draft.startTime}
                    onChange={value => putDraft({
                        startTime: value
                    })}
                >
                    <SelectView.Option value={"09:00"}>9:00 AM to 12:00
                        PM</SelectView.Option>
                    <SelectView.Option value={"14:00"}>2:00 PM to 5:00
                        PM</SelectView.Option>
                    <SelectView.Option value={"19:00"}>7:00 PM to 10:00
                        PM</SelectView.Option>
                </SelectView>
            </Control>
            <Control>
                <LabelView>{T('Delivery Method')}</LabelView>
                <SelectView value={draft.modeOfDelivery}
                            onChange={value => putDraft({
                                modeOfDelivery: value
                            })}>
                    <SelectView.Option
                        value={"delivery-only"}>{T('Delivery')}</SelectView.Option>
                </SelectView>
            </Control>
            <ControlRow>
                <Control>
                    <LabelView2>{T('Postal Code')}</LabelView2>
                    <InputView
                        value={draft.postalCode}
                        onChange={event => {
                            const code = (event.target.value || "").substring(0, 6).replace(/\D/g, '');
                            putDraft('postalCode', code)
                        }}
                        disabled={!!postalCode && draft?.schedule?.isOnsite && draft?.schedule?.regions?.length > 0}/>
                </Control>
                <div style={{width: 12}}/>
                <Control>
                    <LabelView2>{T('Unit No.')}</LabelView2>
                    <InputView value={draft.unitNo}
                               onChange={event => putDraft('unitNo', event.target.value)}/>
                </Control>
            </ControlRow>
            <Control>
                <LabelView2>{T('Address')}</LabelView2>
                <TextAreaView value={draft.address} autoSize={{minRows: 3, maxRows: 12}}
                              onChange={event => putDraft('address', event.target.value)}/>
            </Control>
        </>
    )
}